import React from 'react';
import DashboardModal from '@/components/dashboard-modal';
import { ProspectForm } from './prospect-form/ProspectForm';

interface AddProspectModalProps {
  isOpen: boolean;
  onClose: () => void;
  status?: string;
}

const AddProspectModal = ({ isOpen, onClose, status = 'lead' }: AddProspectModalProps) => {
  const handleFormSubmit = (success: boolean) => {
    if (success) {
      onClose();
    }
  };

  return (
    <DashboardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Contact"
      size="lg"
      accentColor="purple"
    >
      <ProspectForm 
        status={status}
        onSubmit={handleFormSubmit}
      />
    </DashboardModal>
  );
};

export default AddProspectModal;
